import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';

import VendorCatalogs from '.';

const paths = {
  vendorCatalogs: '/inventory/vendor-catalogs',
};

export default [
  <RouteIfRights
    exact
    path={paths.vendorCatalogs}
    component={VendorCatalogs}
    key={paths.vendorCatalogs}
    rights="vendors"
  />,
];
